// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2vVrI","savePackageButton":"ClientWallet_savePackageButton__3grGI"};